﻿<script setup lang="ts">
    import anonymizationManager from '@cwd/Account/AnonymizationManager.vue';
    import mergeContactManager from '@cwd/Account/MergeContactManager.vue';
    import Tabs, { tab } from '@shared/components/Tabs.vue';
    import { ref } from 'vue';

    const mergeTabActivated = ref(false);
</script>

<script lang="ts">
    export default {
        name: 'DataManagement',
    };
</script>

<template>
    <h2 class="main-title">{{ $Resources.DataManagementHeading }}</h2>
    <tabs>
        <tab :title="$Resources.DataManagementTabInactiveContactsLabel">
            <anonymization-manager></anonymization-manager>
        </tab>

        <tab :title="$Resources.DataManagementTabMergeContactsLabel" @tabClick="mergeTabActivated = true">
            <merge-contact-manager v-if="mergeTabActivated"></merge-contact-manager>
        </tab>
    </tabs>
</template>
